// extracted by mini-css-extract-plugin
export var desktop = "QuickSearch-module--desktop--218f7";
export var mobile = "QuickSearch-module--mobile--42f54";
export var pages = "QuickSearch-module--pages--aa4ba";
export var toggleWrapper = "QuickSearch-module--toggleWrapper--2a31b";